<template>
  <div class="wf-node wf-step">
    <Handle id="in" type="target" :position="Position.Left" :style="{ top: '22px' }" />

    <div class="wf-step__header" :title="data.step.name">{{ data.step.name }}</div>
    <div ref="body" class="wf-step__body">
      <StepBlocks :list-items="data.step.evaluate || []" :step="data.step" :steps="data.steps" />
    </div>

    <!-- one source port per outgoing transition block, aligned to its row -->
    <Handle v-for="port in ports" :id="port.id" :key="port.id" type="source" :position="Position.Right" :style="{ top: `${port.topNum}px` }" />
  </div>
</template>

<script>
import { Handle, Position, useVueFlow } from '@vue-flow/core';
import StepBlocks from './StepBlocks.vue';

export default {
  name: 'StepNode',
  components: { Handle, StepBlocks },
  props: {
    id: { type: String, required: true },
    data: { type: Object, default: () => ({}) },
  },
  emits: ['portsMeasured'],
  setup() {
    const { updateNodeInternals } = useVueFlow();
    return { updateNodeInternals };
  },
  data() {
    return { Position, ports: [] };
  },
  watch: {
    'data.step.evaluate': {
      handler() {
        this.$nextTick(this.measure);
      },
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(this.measure);
    // re-measure when the rendered content changes height (nested conditions etc.)
    if (window.ResizeObserver) {
      this.ro = new ResizeObserver(() => this.measure());
      this.ro.observe(this.$el);
    }
  },
  beforeUnmount() {
    if (this.ro) this.ro.disconnect();
  },
  methods: {
    // Place a source handle at the vertical centre of each outgoing block's row.
    // offsetTop is layout-space (unaffected by canvas zoom) and, because the node
    // root is the only positioned ancestor, is measured relative to the node.
    measure() {
      const root = this.$el;
      if (!root) return;
      const ids = this.data.portIds || [];
      const ports = [];
      ids.forEach((blockId) => {
        const el = root.querySelector(`[id="${blockId}"]`);
        if (el) ports.push({ id: blockId, topNum: el.offsetTop + el.offsetHeight / 2 });
      });
      const changed = ports.length !== this.ports.length || ports.some((p, i) => !this.ports[i] || this.ports[i].topNum !== p.topNum || this.ports[i].id !== p.id);
      if (changed) {
        this.ports = ports;
        // tell vue-flow the (dynamic) handles moved, and let the parent align the
        // external endpoint nodes to each port's vertical position.
        this.$nextTick(() => this.updateNodeInternals([this.id]));
        this.$emit('portsMeasured', { nodeId: this.id, ports });
      }
    },
  },
};
</script>
